/**
 * CreateStore queries
 */
import gql from 'graphql-tag'

export const desginsQuery = gql`
  query GetDesigns(
    $limit: Int
    $offset: Int
    $userId: String
  ) {
    designsResult: myDesignsForPrint(
      limit: $limit
      offset: $offset
      userId: $userId
    ) {
      fullCount
      designs {
        id
        code
        name
        shared
        image
        archived
        shortId: short_id
        onBatchStore
        proDesign: pro_design
        proCertified: pro_certified
        qualityWarning: quality_warning
        isDraft: is_draft
        createdAt: created_at
        proDesignItem {
          specialNote: special_note
        }
        product {
          id
          name
          code
          active
          yotpoId: yotpo_id
          type: name
          weight
          discontinued
          onlyProDesign: only_pro_design
          description: short_description
          images: original_pictures {
            front: front_image
            thumbnail
          } 
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignsPrintModal/data.ts